import { GEOZONE_FIELDS_BY_REGION_TYPES } from "helpers/map";
import { ITEM_ROOT } from "odata-query";

export function buildFilter(filtered) {
    const filter = {};

    for (const key in filtered) {
        const item = filtered[key];
        const { filterType, isMulti, value, id } = item;
        switch (filterType) {
            case "dateTimeRange": {
                if (!value.start && !value.end) {
                    break;
                }
                filter[id] = {
                    ...(value.start ? { ge: new Date(value.start) } : {}),
                    ...(value.end ? { le: new Date(value.end) } : {}),
                };
                break;
            }
            case "select": {
                if (isMulti) {
                    if (!Array.isArray(value) || value.length === 0) {
                        break;
                    }
                    const idVal = value.map((v) => parseInt(v));
                    if (idVal.some(isNaN)) {
                        break;
                    }
                    filter[id] = { any: { id: { in: idVal } } };
                } else {
                    const idVal = parseInt(value);
                    if (!isNaN(idVal)) {
                        filter[id] = { [id]: { eq: idVal } };
                    }
                }
                break;
            }
            default: {
                switch (id) {
                    case "to":
                        filter[`to/${GEOZONE_FIELDS_BY_REGION_TYPES[value.type]}`] = { in: [value.id] };
                        break;
                    case "userGroupId":
                        filter.car = {
                            ...(filter.car || {}),
                            groupIds: { any: { [ITEM_ROOT]: { in: value } } },
                        };
                        break;
                    case "regionGroupId":
                        filter["to/stateId"] = { in: value.regionIds };
                        break;
                    default:
                        filter[id] = { in: value };
                        break;
                }
                break;
            }
        }
    }
    return filter;
}
